var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayUnique, IsArray, IsNotEmpty, IsString, IsUUID } from 'class-validator';
/**
 * #813 — declarative per-patient create. The server re-runs the reader,
 * filters to `selectedTreatmentUnitIds`, applies the consolidation decision via
 * the grouper, and assembles one draft per resulting group.
 *
 * - `selectedTreatmentUnitIds` is the per-unit selection (default-all in the
 *   modal). The command drops any selected id that is no longer in the
 *   reader's `eligible[]` (race / drift) and reports it in `skipped[]`.
 * - `consolidatedClusterKeys` lists the deterministic cluster keys the
 *   operator toggled "Auf einer Rechnung zusammenfassen" for. Unknown keys
 *   are silently ignored — the grouper is authoritative; the client can
 *   never submit an illegal cross-cluster group.
 */
export class CreatePatientInvoicesDto {
    patientId;
    selectedTreatmentUnitIds;
    consolidatedClusterKeys;
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreatePatientInvoicesDto.prototype, "patientId", void 0);
__decorate([
    IsArray(),
    ArrayUnique(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], CreatePatientInvoicesDto.prototype, "selectedTreatmentUnitIds", void 0);
__decorate([
    IsArray(),
    ArrayUnique(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], CreatePatientInvoicesDto.prototype, "consolidatedClusterKeys", void 0);
//# sourceMappingURL=create-patient-invoices.dto.js.map